import script from "./DepreciationView.vue?vue&type=script&setup=true&lang=js"
export * from "./DepreciationView.vue?vue&type=script&setup=true&lang=js"

import "./DepreciationView.vue?vue&type=style&index=0&id=4db41438&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db41438"]])

export default __exports__